/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
let n=null;function t(t){n=t}function u(){return n}export{u as getLoader,t as registerLoader};
